<form id="inputForm" *ngIf="step$ | async as step" [formGroup]="inputForm" (ngSubmit)="submit(step)" [hidden]></form>
<div class="row text-center justify-content-center mt-3">

  <ng-template #live>
    <div class="row w-100 justify-content-center">
      <div class="col-12 col-sm-8 col-md-6">
        <video class="border w-100" autoplay #video [srcObject]="videoStream$ | async"></video>
        <canvas hidden #canvas></canvas>
      </div>
    </div>
    <div class="row w-100 justify-content-center mt-2" *ngIf="showTakeShot$ | async">
      <button type="button" mat-raised-button color="accent" (click)="takeShot(video, canvas)">
        <mat-icon>camera</mat-icon>
      </button>
    </div>
  </ng-template>

  <ng-container *ngIf="preview$ | async as preview; else live">
    <div class="row w-100 justify-content-center">
      <div class="col-12 col-sm-8 col-md-6">
        <img [src]="preview.src" class="border w-100">
      </div>
    </div>
    <div class="row w-100 justify-content-center mt-2">
      <button type="button" class="mr-2" mat-raised-button color="warn" (click)="discardPreview()">
        <mat-icon>close</mat-icon>
      </button>
      <button type="button" mat-raised-button color="accent" (click)="confirmPreview(preview.src)">
        <mat-icon>done</mat-icon>
      </button>
    </div>
  </ng-container>

  <div class="row w-100 justify-content-center mt-2" *ngIf="acquired$ | async as acquired">
    <div class="col-6 col-sm-3 col-md-2" *ngFor="let img of acquired">
      <img class="border w-100" [src]="img" (click)="removeFromAcquired(img)">
    </div>
  </div>

</div>
